module.exports = __webpack_public_path__ + "static/img/6.b04bd2d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/eng/6.png
// module id = GzN2
// module chunks = 0